module.exports = __webpack_public_path__ + "static/media/bg_mobile.bc1be8cb.png";